import State from '../../../../domain/country/state/State';
import StateRepresentation from './StateRepresentation';

export default (
  translator,
) => () => {
  const states = State.all();
  return states.map((state) => state.representedAs(new StateRepresentation(translator)));
};
